// var recherche_ouverte = false;
// function rechercher(){
//     if (!recherche_ouverte){
//         recherche_ouverte = true;
//         $("#chercher a").css("background-position","0 -128px");
//         $("#formchercher input").show();
//         $("#formchercher input").animate({width: 107}, 400);
//         $("#menuhaut #menurub").animate({marginLeft: 283}, 400);
//         $(".bandeau_nav").each(function (){
//             $("div",this).css("margin-left","270px");
//         });
//     }
//     else
//         $("#formchercher").submit();
// }

(function($){
  $(document).ready(function() {

    $('.recherche_link').on('click', function(e){
        e.preventDefault();
        $('#formchercher').toggleClass('open').find('input[name="rechercher"]').focus();
        $('.masque').show().toggleClass('masque-recherche');
    });

  })
})(jQuery);
